import { MapperBase } from '../../utilities/mapper-base';
import { ReviewEntryResource } from '@models/resource/review-entry.resource';
import { ReviewEntry } from '@models/ui/review-entry.model';
import { DocumentReviewValidationRuleType } from 'src/app/enums/document-review-validation-rule-type.enum';
import { DocumentReviewValidationStatus } from 'src/app/enums/document-review-validation-status.enum';
import { DocumentReviewValidationRuleTypeToValidationMessage } from './maps/document-review-validation-rule-type-to-validation-message.resource.map';

export class ReviewEntryResourceToReviewEntryMapper extends MapperBase<ReviewEntryResource, ReviewEntry> {
	map(source: ReviewEntryResource): ReviewEntry {
		const dest = new ReviewEntry();
		dest.caseId = source.caseId;
		dest.reviewSetId = source.reviewSetId;
		dest.docId = source.docId;
		dest.reviewOrder = source.reviewOrder;
		dest.status = source.status;
		dest.userId = source.userId;
		dest.emailFamilyId = source.emailFamilyId;
		dest.emailParentId = source.emailParentId;
		dest.documentTitle = source.documentTitle;
		dest.hasBeenReviewed = source.hasBeenReviewed;
		if (source.validationErrors) {
			dest.validationErrors = source.validationErrors;
			dest.validationMessage = source.validationErrors.map(e => DocumentReviewValidationRuleTypeToValidationMessage.get(e)).join(' ');
			let status = DocumentReviewValidationStatus.None;
			const hasErrors = false;
			const hasWarnings = source.validationErrors.includes(DocumentReviewValidationRuleType.MissingRedactedPdf)
			|| source.validationErrors.includes(DocumentReviewValidationRuleType.PartialPrivilegedCoding)
			|| source.validationErrors.includes(DocumentReviewValidationRuleType.PartialPrivilegedRedaction);
			const hasInfo = source.validationErrors.includes(DocumentReviewValidationRuleType.PageCount)
			|| source.validationErrors.includes(DocumentReviewValidationRuleType.ResponsiveInvalid)
			|| source.validationErrors.includes(DocumentReviewValidationRuleType.ResponsiveEmailFamily)
			|| source.validationErrors.includes(DocumentReviewValidationRuleType.PrivilegeEmailFamily) 
			|| source.validationErrors.includes(DocumentReviewValidationRuleType.WorkProductEmailFamily);
			if (hasErrors)
				status = DocumentReviewValidationStatus.Error;
			else if (hasWarnings)
				status = DocumentReviewValidationStatus.Warnings;
			else if (hasInfo)
				status = DocumentReviewValidationStatus.Info;

				dest.validationStatus = status;
		} else {
			dest.validationStatus = DocumentReviewValidationStatus.None;
		}

		if (source.emailParentId !== source.docId) {
			dest.relationship = 'child';
		} else if (source.emailParentId === source.docId && source.hasChildren) {
			dest.relationship = 'parent';
		} else {
			dest.relationship = 'standalone';
		}
		return dest;
	}
}
